import i18next from 'i18next';

import { Row, Col, Card, Badge } from 'react-bootstrap';
import { RoleEnum, Stats } from 'src/api';
import { HiDocumentText } from 'react-icons/hi';
import { FaTrophy } from 'react-icons/fa';
import { BiEuro } from 'react-icons/bi';
import _ from 'lodash';
import { useAuth } from 'src/hooks/useAuth';
import React, { useMemo } from 'react';

function StatsBar(
  {
    className,
    stats,
    period,
  }:
    {
      className?: string;
      stats: Stats;
      period: { start: string; end: string },
      labelProvvigioniSegnalatore?: React.ReactNode
    }
) {
  const { userRole } = useAuth();

  const labelProvvSegnalatoreByRole = useMemo(() => {
    switch (userRole) {
      case RoleEnum.MASTER:
      case RoleEnum.BACKOFFICE:
      case RoleEnum.AREA_MANAGER:
        return i18next.t('Provvigioni_segnalatore__c');
      case RoleEnum.SEGNALATORE:
        return i18next.t('commissions_no_currency')
      case RoleEnum.SALES:
      case RoleEnum.SALES_DEALER:
        return i18next.t('Provvigioni_segnalatore__c')
      default:
        return i18next.t('commissions_to_be_paid');
    }
  }, [userRole])

  const labelProvvigioniDealerVinteByRole = useMemo(() => {
    switch (userRole) {
      case RoleEnum.MASTER:
      case RoleEnum.BACKOFFICE:
      case RoleEnum.AREA_MANAGER:
        return i18next.t('provvigioni_maturate_dealer');
      case RoleEnum.SALES:
      case RoleEnum.SALES_DEALER:
        return i18next.t('provvigioni_maturate_dealer')
      default:
        return i18next.t('provvigioni_maturate');
    }
  }, [userRole])

  const showProvvigioniMaturate = [RoleEnum.MASTER, RoleEnum.BACKOFFICE, RoleEnum.AREA_MANAGER, RoleEnum.SALES_DEALER, RoleEnum.SALES].includes(userRole);
  const cols = showProvvigioniMaturate ? 3 : 4;

  return (
    <Col xl={12} className={className}>
      <Card>
        <Card.Header>
          <Badge bg="warning" text="dark">
            {period.start} - {period.end}
          </Badge>
        </Card.Header>
        <Card.Body className="pt-0">
          <Row className="g-4">
            <Col xl={cols} md={4} className="md-border-end">
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded me-3"
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#2c3e50',
                    flexShrink: 0
                  }}
                >
                  <HiDocumentText className="text-white" size={28} />
                </div>
                <div>
                  <div className="small mb-1">{i18next.t('total_opportunities_created')}</div>
                  <h4 className="mb-0 fw-bold">{stats.opportunityCreated}</h4>
                </div>
              </div>
            </Col>

            <Col xl={cols} md={4} className="md-border-end">
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded me-3"
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#2c3e50',
                    flexShrink: 0
                  }}
                >
                  <FaTrophy className="text-white" size={28} />
                </div>
                <div>
                  <div className="small mb-1">{i18next.t('opportunities_won')}</div>
                  <h4 className="mb-0 fw-bold">{stats.opportunityWon}</h4>
                </div>
              </div>
            </Col>

            <Col xl={cols} md={4}>
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded me-3"
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#2c3e50',
                    flexShrink: 0
                  }}
                >
                  <BiEuro className="text-white" size={32} />
                </div>
                <div>
                  <div className="small mb-1">{labelProvvSegnalatoreByRole}</div>
                  <h4 className="mb-0 fw-bold">{stats.provvigioniSegnalatore?.toFixed(2) || '0.00'}</h4>
                </div>
              </div>
            </Col>
            {showProvvigioniMaturate && (
              <Col xl={cols} md={4}>
                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center rounded me-3"
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#2c3e50',
                      flexShrink: 0
                    }}
                  >
                    <BiEuro className="text-white" size={32} />
                  </div>
                  <div>
                    <div className="small mb-1">{labelProvvigioniDealerVinteByRole}</div>
                    <h4 className="mb-0 fw-bold">{stats.provvigioniDealerVinte?.toFixed(2) || '0.00'}</h4>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
}


export default StatsBar;
